// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__K9zrx","content":"styles_content__31g6S"};